import organisatorApi from "../../../api/e-loket/organisatorApi";
import contactApi from "../../../api/shared/contactApi";
import FilesHelper from "../../common/FilesHelper";
import * as messages from "../../../constants/ToastrConstants";
import { showToastrError, showToastrWarning, showToastrSuccess } from "../../../util/toastr";
import { Landen, RechtspersoonlijkheidTypes } from "../../../constants/DomainConstants";
import { ValidationMessageTypes } from "../../../constants/ComponentConstants";


import assign from 'object-assign';

export default class OrganisatorPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		const params = context.props.match.params;
		let pageDisabled = null;
		if (params.isDisabled != undefined) pageDisabled = params.isDisabled === "true";
		const modelId = params.modelId;

		if (pageDisabled === true || pageDisabled === false)
			context.props.disablePage(pageDisabled);

		const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

		context.filesHelper = new FilesHelper(context, modelId);
		ajaxActions.started();
		if (modelId) {
			return organisatorApi.get(modelId)
				.then((response) => {
					ajaxActions.ended();
					this.processModel(response, pageDisabled);
					this.loadContacts(response.data.organisator.id);
				})
				.catch((ex) => {
					ajaxActions.failed();
					context.props.throwException(ex);
				});
		}

		context.setState({
			modelId,
			returnUrl
		});
	}

	processModel(response, isPageDisabled) {
		const context = this.context;
		let model = response.data;
		const herkomst = context.props.match.params.herkomst;

		context.setState({
			model
		});

		context.props.loadLayout(model.naam, model.id, model.validatiestatusses, isPageDisabled, herkomst, response.data.svlDossierId, model.redenVanStatus);
		context.props.validatieStatussenLoaded(model.validatiestatusses);
	}

	loadContacts(organisatorId) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		ajaxActions.started();
		contactApi.getContactsByAccount(organisatorId).then((response) => {
			ajaxActions.ended();
			this.processContactpersonen(response);
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processContactpersonen(response) {
		const context = this.context;

		let list = response.data ? response.data.map(k => { return { value: k.id, label: k.voornaam + ' ' + k.naam }; }) : null;
		if (list) list.push({ value: "newContact", label: "Nieuwe contactpersoon" });

		context.setState({
			contactpersonenLabelValuePair: list,
			contactpersonen: response.data
		});
	}

	save() {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const state = context.state;

		context.filesHelper.commitSession();

		let errors = null;
		let model = null;

		let modelToSave = context.state.model;

		let scrollToTop = false;

		ajaxActions.started();
		return organisatorApi.save(modelToSave).then((response) => {
			ajaxActions.ended();

			if (response.statusText === "OK" && !response.data.hasValidationErrors) {
				if (Object.keys(response.data.validationResults).length !== 0) {
					model = assign({}, response.data.item);
					errors = assign({}, response.data.validationResults);
					showToastrWarning(messages.MESSAGE_VALIDATION_ERRORS_SAVED, true);
				}
				else {
					model = assign({}, response.data.item, {});
					errors = {};
					scrollToTop = true;
				}

				context.setState({
					hasUnsavedChanges: false,
					scrollToTop: scrollToTop
				});

				showToastrSuccess(messages.MESSAGE_SAVED, true);
			} else {
				errors = assign({}, response.data.validationResults);
				model = assign({}, response.data.item, {});
				showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
			}

			if (context.state.shouldReloadContactpersonen) {
				this.loadContacts(context.state.model.organisator.id);
			}

			context.props.validatieStatussenLoaded(model.validatiestatusses);
			context.setState({
				errors: errors,
				model,
				validationMessageType: response.data.hasValidationErrors ? ValidationMessageTypes.ERROR : ValidationMessageTypes.WARNING,
				shouldReloadContactpersonen: false,
				showErrors: true,
				showAnbPopup: model.showAnbPopup,
				shouldScrollToFirstError: true
			});
		})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}



	changeChildModel(event, childModelName) {
		const value = event.target.type === "checkbox" ? event.target.checked : event.target.type === "radio" ? event.target.value === "true" ? true : false : event.target.value;
		const property = event.target.name;

		const model = this.context.state.model;

		if (property === "nietAangesloten" && value === true)
			model.organisator.aangeslotenBijId = null;

		if (property === "rechtspersoonlijkheidId" && value !== RechtspersoonlijkheidTypes.ANDERE)
			model.organisator.andereRechtspersoonlijkheid = "";

		if (property === "land" && value === Landen.BELGIE) {
			model[childModelName].gemeente = "";
			model[childModelName].postcode = "";
		}

		if (property === "land" && value !== Landen.BELGIE) {
			model[childModelName].gemeenteBE = "";
			model[childModelName].postcodeBE = "";
		}

		if (childModelName === "contactpersoon" || childModelName === "contactpersoonTijdensActiviteit") {
			this.context.setState({
				shouldReloadContactpersonen: true
			});

			if (property === "id") {
				const chosenContact = this.context.state.contactpersonen.find(x => x.id === value);

				Object.keys(model[childModelName]).forEach(k => {
					model[childModelName][k] = chosenContact ? chosenContact[k] : null;
					model[childModelName].land = chosenContact && chosenContact.land ? chosenContact.land : Landen.BELGIE;

					model[childModelName].postcode = chosenContact ? chosenContact.postcodeNietBelgie : "";
					model[childModelName].postcodeBE = chosenContact ? chosenContact.postcode : "";
					model[childModelName].gemeente = chosenContact ? chosenContact.gemeenteNietBelgie : "";
					model[childModelName].gemeenteBE = chosenContact ? chosenContact.gemeente : "";
				});

				if (childModelName === "contactpersoonTijdensActiviteit")
					model[childModelName].andereContactpersoonTijdensActiviteit = true;
			}
		}

		model[childModelName][property] = value;
		this.context.setState({
			model,
			hasUnsavedChanges: true,
			showAnbPopup: false
		});
	}

	getErrorForChildModelProperty(propertyName, childModelName) {
		const errors = this.context.state.errors;
		const showErrors = this.context.state.showErrors;

		return errors && errors[childModelName] && showErrors ? errors[childModelName][propertyName] : null;
	}

	confirmAnbPopup() {
		this.context.setState({
			showAnbPopup: false
		});
	}
}
